import { FC } from "react";

export const CustomizedButton: FC<{ text: string }> = ({ text }) => {
  return (
    <button className="group relative h-12 w-48 overflow-hidden rounded-lg bg-white text-lg shadow">
      <div
        style={{ background: "#2E5242" }}
        className="absolute inset-0 w-3 transition-all duration-[250ms] ease-out group-hover:w-full"
      />
      <span className="relative text-black group-hover:text-white">{text}</span>
    </button>
  );
};
